import wixWindow from 'wix-window';
let formFactor = wixWindow.formFactor;

$w.onReady(function () {
  if (formFactor === "Mobile") { 
      $w("#textDownloadApp").text = "Download now"
  }
});

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function image27_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
 *	Adds an event handler that runs when the element is double-clicked.
 *	 @param {$w.MouseEvent} event
 */
export function image27_dblClick(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}